import { render, staticRenderFns } from "./DashboardIcon2.vue?vue&type=template&id=13d10fe4"
import script from "./DashboardIcon2.vue?vue&type=script&lang=js"
export * from "./DashboardIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports